import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  DtpTable,
  DtpTableHeader,
  DtpNoContent,
} from 'dtp-react-components';
import { ExportToCsv } from 'export-to-csv';
import {
  Button,
} from '../../components/index';
import {
  doPost,
} from '../../utils/requests';
import * as listUtils from '../../utils/listsSelect';

const colunasRelatorioTotalizador = [
  'Cpf',
  'Nome',
  'Matrícula',
  'Solicitante',
  'Destinatário',
  'Estado',
  'Detalhe',
];

class NovoRelatorioTotalizadorEstados extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showNoContent: false,
      noContentPrimaryMessage: null,
      noContentSecondaryMessage: null,
      legendaRelatorio: null,
    };
  }

gerarCsv = (lista) => {
  if (lista && lista !== undefined && lista.length > 0) {
    const csvExporter = new ExportToCsv({
      filename: 'relatorio',
      fieldSeparator: ';',
      showTitle: true,
      title: this.state.legendaRelatorio,
      showLabels: true,
      headers: colunasRelatorioTotalizador,
    });
    csvExporter.generateCsv(lista);
  }
};

prepararColunasExportacao = (data) => {
  const dados = data.map((item) => {
    const linha = Object.assign({}, item);
    return linha;
  });
  return dados;
};

addTipoEstadoLabel = (tipo) => {
  if (tipo === 15) {
    return 'Exigência/indeferido';
  }

  if (tipo === 16) {
    return 'Indeferimento ratificado';
  }

  if (tipo === undefined || tipo === null) {
    return '';
  }

  return listUtils.getObject(listUtils.tiposEstado, tipo).label;
}

extrairColunasJson = (data) => {
  let objetoLinha = {};
  const dados = data.map((item) => {
    const objSolicitante = `${item[Object.keys(item)[1]]}-${item[Object.keys(item)[0]]}`;
    const objDestinatario = `${item[Object.keys(item)[3]]}-${item[Object.keys(item)[2]]}`;
    objetoLinha = {
      cpf: this.pesquisarColunaJson(item, 'cpf'),
      nome: this.pesquisarColunaJson(item, 'nome'),
      matricula: this.pesquisarColunaJson(item, 'matricula'),
      solicitante: objSolicitante,
      destinatario: objDestinatario,
      estado: this.addTipoEstadoLabel(this.pesquisarColunaJson(item, 'estado')),
      protocolo: this.pesquisarColunaJson(item, 'protocolo'),
    };
    return objetoLinha;
  });
  return dados;
};

pesquisarColunaJson = (json, coluna) => {
  let retorno = json[coluna];
  if (retorno === undefined) {
    retorno = '';
  }
  return retorno;
}

tratarSucessoListaExportacao = (response) => {
  if (response.data !== '') {
    const lista = this.extrairColunasJson(response.data);
    const dadosFormatados = this.prepararColunasExportacao(lista);
    this.setState({
    }, this.gerarCsv(dadosFormatados));
  }
};

tratarErro = () => {
  const mensagemPrimaria = 'Não foi possível consultar os requerimentos.';
  const mensagemSecundaria = 'Contate o administrador do sistema.';
  this.setState({
    showNoContent: true,
    noContentPrimaryMessage: mensagemPrimaria,
    noContentSecondaryMessage: mensagemSecundaria,
  });
};

preparaRequest = (url, parametros) => {
  doPost(
    url,
    parametros,
    this.tratarSucessoListaExportacao,
    this.tratarErro,
  );
};

exportarCsv = (props) => {
  this.setState({
    legendaRelatorio: props.legend,
  });
  if (props.urlExportacao && props.parametrosExportacao) {
    const parametros = props.parametrosExportacao;
    parametros['start-position'] = 0;
    parametros['max-results'] = 100000;
    this.preparaRequest(props.urlExportacao, parametros);
  }
};

render() {
  if (this.state.showNoContent) {
    return (
      <DtpNoContent
        primaryText={this.state.noContentPrimaryMessage}
        secondaryText={this.state.noContentSecondaryMessage}
        show={this.state.showNoContent}
      />);
  }
  return (
    <React.Fragment>
      {this.props.nomeRelatorio !== '' ? (
        <React.Fragment>
          {this.props.data && this.props.data.length > 0 ? (
            <Button
              hint="Exportar para CSV"
              onClick={() => { this.exportarCsv(this.props); }}
              icon="ico-doc-sheet"
              mini
            />
          ) : ''}
          <div className="relatorio" style={{ '--relatorioWidth': this.props.containerStyle.width }}>
            <DtpTable {...this.props}>
              {this.props.headers.map((item, i) => (
                <DtpTableHeader
                  key={item}
                  dataField={this.props.data[0] ? Object.keys(this.props.data[0])[i] : 'default'}
                  dataAlign="center"
                  isKey={i === 0}
                  header={item}
                  tdStyle={{ wordBreak: 'break-word' }}
                  dataFormat={this.props.dataFormatOptions[i]}
                  hidden={this.props.options.hidden && this.props.options.hidden.includes(i)}
                />))}
            </DtpTable>
          </div>
        </React.Fragment>
      ) : null
      }
    </React.Fragment>
  );
}
}

NovoRelatorioTotalizadorEstados.propTypes = {
  dataFormatOptions: PropTypes.object,
}.isRequired;

NovoRelatorioTotalizadorEstados.defaultProps = {
  voltarAction: () => null,
};

export default NovoRelatorioTotalizadorEstados;



// WEBPACK FOOTER //
// ./src/pages/relatorios/NovoRelatorioConflitoPeriodos.jsx